import Header from "@shared/components/Atoms/Contents/Header";
import FooterMain from "@shared/components/Atoms/Contents/FooterMain";
import { FOOTER } from "@shared/util/brand";

function ComplianceShell({ title, children }) {
  return (
    <div>
      <a
        href="#compliance-main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-3 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded-lg"
      >
        Skip to main content
      </a>
      <Header />
      <main id="compliance-main" className="container mx-auto px-4 py-8 max-w-4xl my-10">
        <h1 className="text-4xl font-bold text-gray-900 mb-6">{title}</h1>
        <div className="prose prose-gray max-w-none space-y-6 text-gray-700">{children}</div>
      </main>
      <FooterMain />
    </div>
  );
}

export function CookiePolicy() {
  const email = FOOTER.email || "agent@videobrief.ai";
  return (
    <ComplianceShell title="Cookie Policy">
      <p>
        <strong>Last updated:</strong> June 30, 2026
      </p>
      <p>
        This Cookie Policy explains how VideoBrief (&quot;we&quot;, &quot;us&quot;) uses cookies and
        similar technologies on videobrief.ai and related applications. It supplements our{" "}
        <a href="/privacy-policy" className="text-blue-700 underline">
          Privacy Policy
        </a>
        .
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mt-8">What we use</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>
          <strong>Strictly necessary</strong> — authentication tokens, security (e.g. Cloudflare
          Turnstile on forms), session integrity, and load balancing. Required to use the service.
        </li>
        <li>
          <strong>Functional</strong> — live support chat session IDs, theme preference, and similar
          features that remember your choices. Disabled if you reject non-essential cookies.
        </li>
        <li>
          <strong>Analytics</strong> — aggregated usage measurement to improve the product. We do
          not use analytics cookies for cross-context behavioral advertising.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mt-8">Your choices (including California)</h2>
      <p>
        When you first visit, you may <strong>Accept all</strong>,{" "}
        <strong>Reject non-essential</strong>, or <strong>Customize</strong> categories. California
        residents may also opt out of the sale or sharing of personal information via our{" "}
        <a href="/do-not-sell-or-share" className="text-blue-700 underline">
          Do Not Sell or Share
        </a>{" "}
        page or the preference center (link in the site footer: Cookie settings).
      </p>
      <p>
        VideoBrief does <strong>not</strong> sell your personal information for money. We do not
        share personal information for cross-context behavioral advertising. Your opt-out choice is
        stored locally in your browser.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mt-8">Browser controls</h2>
      <p>
        You can delete or block cookies through your browser settings. Blocking strictly necessary
        cookies may prevent login or core features from working.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mt-8">Contact</h2>
      <p>
        Questions:{" "}
        <a href={`mailto:${email}`} className="text-blue-700 underline">
          {email}
        </a>{" "}
        or live chat (requires functional cookies).
      </p>
    </ComplianceShell>
  );
}

export default CookiePolicy;
